;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .constant('AGILE_CENTRAL_FIELD_KEYS', {
      OWNER: 'Owner',
      STATE: 'State',
      SUBMITTED_BY: 'SubmittedBy',
      ENVIRONMENT: 'Environment'
    })
    .constant('AGILE_CENTRAL_OBJECT_PROPERTIES', {
      STRING_VALUE: 'stringValue',
      REFERENCE: 'ref'
    })
    .constant('AGILE_CENTRAL_PROPERTIES', {
      OWNER: 'owner',
      SUBMITTED_BY: 'submittedBy'
    })
    .constant('BUGTRACKER_UNUSED_FIELD_VALUE', 'UNUSED')
})()
